<template>
  <v-container justify-center pa-0 class="text-center">
    <div class="text-h5">{{ $t("message.not_an_admin") }}</div>
    <v-card-text>
      <v-icon color="error" size="100">mdi-alert-octagon</v-icon>
    </v-card-text>
    <v-card-text>
      <div class="text-center mt-2">
        <AcademySelect :label="$t('message.select_academy')" outlined :force-select="true"></AcademySelect>
      </div>
    </v-card-text>
    <v-card-text>
      <div>
        <v-btn color="error" elevation="0" small @click="logout()">
          <v-icon class="mr-1">mdi-logout</v-icon>
          {{ $t("message.logout") }}</v-btn>
      </div>
    </v-card-text>
    <icon-master size="400px" color="red"></icon-master>
  </v-container>
</template>
<script>
import AcademySelect from "@/components/inputs/AcademySelect.vue";
export default {
  components: {
    AcademySelect
  },
};
</script>

<style scoped></style>
